export function getAll() {
  return [
    {
      value: 0,
      name: "0",
      text: "0個月",
    },
    {
      value: 1,
      name: "1",
      text: "1個月",
    },
    {
      value: 2,
      name: "2",
      text: "2個月",
    },
    {
      value: 3,
      name: "3",
      text: "3個月",
    },
    {
      value: 4,
      name: "4",
      text: "4個月",
    },
    {
      value: 5,
      name: "5",
      text: "5個月",
    },
    {
      value: 6,
      name: "6",
      text: "6個月",
    },
    {
      value: 7,
      name: "7",
      text: "7個月",
    },
    {
      value: 8,
      name: "8",
      text: "8個月",
    },
    {
      value: 9,
      name: "9",
      text: "9個月",
    },
    {
      value: 10,
      name: "10",
      text: "10個月",
    },
    {
      value: 11,
      name: "11",
      text: "11個月",
    },
    {
      value: 12,
      name: "12",
      text: "12個月",
    },
  ];
}
export function getBirthMonth() {
  return [
    {
      value: 1,
      name: "01",
      text: "1月",
    },
    {
      value: 2,
      name: "02",
      text: "2月",
    },
    {
      value: 3,
      name: "03",
      text: "3月",
    },
    {
      value: 4,
      name: "04",
      text: "4月",
    },
    {
      value: 5,
      name: "05",
      text: "5月",
    },
    {
      value: 6,
      name: "06",
      text: "6月",
    },
    {
      value: 7,
      name: "07",
      text: "7月",
    },
    {
      value: 8,
      name: "08",
      text: "8月",
    },
    {
      value: 9,
      name: "09",
      text: "9月",
    },
    {
      value: 10,
      name: "10",
      text: "10月",
    },
    {
      value: 11,
      name: "11",
      text: "11月",
    },
    {
      value: 12,
      name: "12",
      text: "12月",
    },
  ];
}
